// src/layouts/Pages/PageHeader/CardHeaderColumn/items/subscriptionValue.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { DollarOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';

// *******************************************************************************
// ITEM FUNCTION
// *******************************************************************************
export const subscriptionValueItem = (record, contract) => {
  if (!record?._id) return;

  const label = contract?.MONTHLY_AMOUNT != null
    ? formatCurrency(contract.MONTHLY_AMOUNT, contract.CURRENCY)
    : record?.subscriptionValue || null;

  if (!label) return;

  return {
    key: 'subscriptionValue',
    icon: <DollarOutlined />,
    label,
    tooltipText: translateX('subscription_value'),
    tooltipPlacement: 'right',
    onClick: null,
  };
};

export default subscriptionValueItem;

// *******************************************************************************
// HELPERS
// *******************************************************************************
function formatCurrency(amount, currency = 'BRL') {
  const locale = currency === 'BRL' ? 'pt-BR' : 'en-US';
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  }).format(amount);
}
